import {
    BASE_URL, 
    POST,  
    EXTENSION_ACCESS_REQUEST,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const addEntensionExcessRequest = async (payload) => {
    const token = await getAccessToken();
    const resource = `${BASE_URL}${EXTENSION_ACCESS_REQUEST}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  